import { HelmetProvider } from 'react-helmet-async';

import App from '@/App';
import authConfig from '@/config/auth';
import '@/config/i18n';
import { ChakraProvider, CircularProgress, Flex } from '@chakra-ui/react';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider as StoreProvider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import theme from './theme';

import { Auth } from '@aws-amplify/auth';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from './store';

import TagManager from 'react-gtm-module';

const tagManagerArgs = {
  gtmId: 'GTM-NGNCTV',
};

// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
TagManager.initialize(tagManagerArgs);

Auth.configure(authConfig);

const root = createRoot(document.querySelector('#root') as HTMLElement);

root.render(
  <React.StrictMode>
    <Router>
      <ChakraProvider theme={theme}>
        <StoreProvider store={store}>
          <PersistGate
            loading={
              <Flex alignItems="center" h="100vh" justifyContent="center" w="full">
                <CircularProgress color="brand.red.light" isIndeterminate />
              </Flex>
            }
            persistor={persistor}
          >
            <React.Suspense>
              <HelmetProvider>
                <App />
              </HelmetProvider>
            </React.Suspense>
          </PersistGate>
        </StoreProvider>
      </ChakraProvider>
    </Router>
  </React.StrictMode>
);
